var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.6875C11.9497 19.6875 13.125 18.7081 13.125 17.5C13.125 16.2919 11.9497 15.3125 10.5 15.3125C9.05025 15.3125 7.875 16.2919 7.875 17.5C7.875 18.7081 9.05025 19.6875 10.5 19.6875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.6875C22.4497 19.6875 23.625 18.7081 23.625 17.5C23.625 16.2919 22.4497 15.3125 21 15.3125C19.5503 15.3125 18.375 16.2919 18.375 17.5C18.375 18.7081 19.5503 19.6875 21 19.6875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 19.6875C32.9497 19.6875 34.125 18.7081 34.125 17.5C34.125 16.2919 32.9497 15.3125 31.5 15.3125C30.0503 15.3125 28.875 16.2919 28.875 17.5C28.875 18.7081 30.0503 19.6875 31.5 19.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/three dot.ac5cc1c3c84a9b15dcbed0292f6435bb.svg";
export { ForwardRef as ReactComponent };